import { useEffect } from "react";
import { useParams } from "react-router-dom";

// freightpilotai.ai/go/{partner} — tracked partner/creator link. Bounces through the
// backend so the click is logged, then lands with utm_source=partner&utm_campaign={code}.
export default function PartnerGoPage() {
  const { code } = useParams();
  useEffect(() => {
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/go/${encodeURIComponent(code || "")}`);
  }, [code]);
  return (
    <div className="min-h-screen bg-neutral-950 text-white/60 flex items-center justify-center text-sm" data-testid="partner-go-page">
      Opening FreightPilot AI…
    </div>
  );
}
